"use client";

import { Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { MessageCircle } from "lucide-react";
import { paa } from "@/lib/data/homepage";

/**
 * PAA — People Also Ask. Compact 2-column grid of expandable question
 * cards. Each card shows question + a one-line answer preview.
 */
export function PAA() {
  return (
    <section id="paa" className="relative section-pad">
      <Container>
        <Reveal className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full glass eyebrow-tiny text-[var(--color-amber)]">
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--color-amber)]" />
            People Also Ask
          </span>
          <h2 className="mt-6">
            What Others Are Asking
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {paa.map((p, i) => (
            <Reveal key={p.q} delay={i * 50}>
              <details className="group h-full glass rounded-2xl overflow-hidden">
                <summary className="flex items-start gap-3 px-4 py-4 cursor-pointer list-none hover:bg-[rgb(var(--border)/0.04)] transition-colors">
                  <MessageCircle className="h-4 w-4 mt-0.5 text-[var(--color-amber)] shrink-0" />
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold text-[0.9rem] leading-snug">{p.q}</div>
                  </div>
                </summary>
                <div className="px-4 pb-4 pl-11 text-body-xs leading-relaxed text-[rgb(var(--fg-muted))]">
                  {p.a}
                </div>
              </details>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}
